module.exports = __webpack_public_path__ + "img/icon1.6675b2f6.png";